export default function DescriptionSkeleton() {
  return (
    <div className="homerunner-description-container">
      <div className="space-y-6">
        {Array.from({ length: 1 }).map((_, index) => (
          <div key={index} className="homerunner-description-section">
            <div className="homerunner-description-skeleton h-6 w-1/3 mb-3"></div>
            <div className="space-y-2">
              <div className="homerunner-description-skeleton h-4 w-full"></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
